import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd113bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "SearchDetail_Contents" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "発売日", -1))
const _hoisted_4 = { class: "SearchDetail_Contents_List" }
const _hoisted_5 = {
  key: 0,
  class: "Shinagire_Search_Wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, " 出荷可能在庫＞受注数のみ表示 ", -1))
const _hoisted_7 = { class: "SearchDetail_Contents_List" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品コード", -1))
const _hoisted_9 = { class: "SearchDetail_Contents_List" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "Flex_Wrapper" }
const _hoisted_12 = { class: "Flex_Child" }
const _hoisted_13 = { class: "SearchDetail_Contents" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "種別", -1))
const _hoisted_15 = { class: "SearchDetail_Contents_List" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "Flex_Child" }
const _hoisted_18 = { class: "SearchDetail_Contents" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "カテゴリ", -1))
const _hoisted_20 = { class: "SearchDetail_Contents_List" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "Flex_Child" }
const _hoisted_23 = { class: "SearchDetail_Contents" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "在庫ステータス", -1))
const _hoisted_25 = { class: "SearchDetail_Contents_List" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, null, -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "Shinagire_Flex_Wrapper"
}
const _hoisted_29 = { class: "Shinagire_Flex_Child" }
const _hoisted_30 = { class: "SearchDetail_Contents" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取次", -1))
const _hoisted_32 = { class: "SearchDetail_Contents_List" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "Flex_Child" }
const _hoisted_35 = { class: "SearchDetail_Contents" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "書店", -1))
const _hoisted_37 = { class: "SearchDetail_Contents_List" }

import { ref, watch } from "vue";
import { useStore } from "vuex";
import SearchSimple from "./SearchSimple.vue";
import { useRoute } from "vue-router";
import ModalSyosiList from "../modal/ModalSyosiList.vue";
import ModalShopList from "../modal/ModalShopList.vue";
import InputText from "../atoms/Input/InputText.vue";
import { Notyf } from "notyf";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDetail',
  emits: ["onSearch"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();
const route = useRoute();
const emit = __emit;
const notyf = new Notyf();

// 画面によってストアの値を保持しているので初期値としてセット
const initialSearchConditions = store.getters["search/getSearchState"];
// eslint-disable-next-line no-unused-vars
const searchConditions = ref({
  fromDate: initialSearchConditions.fromDate,
  toDate: initialSearchConditions.toDate,
  syubetu: initialSearchConditions.syubetu,
  category: initialSearchConditions.category,
  zaikoStatus: initialSearchConditions.zaikoStatus,
  syosiCd: initialSearchConditions.syosiCd,
  // 品切保留で使用---------------------------
  changeableSyukkoSuu: false, // 出荷可能在庫>受注数のみ絞り込んで表示する用
  toritugiCd: "",
  toritugiSyotenCd: "",
});

//取次(「全件」項目を追加)
const zenken = { toritugiCd: "", torihikisakiCd: "", toritugiMei: "全件" };
const toritugiList = [zenken, ...store.getters["constant/getToritugiList"]];
//種別
const syubetuList = store.getters["constant/getSyubetuList"];
//カテゴリ
const categoryList = store.getters["constant/getCategoryList"];
//在庫ステータス
const zaikoStatusList = store.getters["constant/getZaikoStatusList"];

//期間の取得
const startDate = () => {
  console.log(searchConditions.value);
};

const onSearch = () => {
  emit("onSearch");
};

// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchConditions.value.fromDate = "";
  searchConditions.value.toDate = "";
  searchConditions.value.syubetu = "";
  searchConditions.value.category = "";
  searchConditions.value.zaikoStatus = "";
  searchConditions.value.syosiCd = "";
  searchConditions.value.changeableSyukkoSuu = false;
  searchConditions.value.toritugiCd = "";
  searchConditions.value.toritugiSyotenCd = "";
  selectedSyoten.value.syotenMei = "";
  selectedSyoten.value.bansen = "";
  selectedSyoten.value.syotenCd = "";
};

// モーダル開閉------------------------------------
let itemModalVisible = ref(false); // 書誌検索モーダル
let syotenModalVisible = ref(false); // 書店検索モーダル
const showModal = (modalName: string): void => {
  if (modalName === "itemModal") {
    itemModalVisible.value = true;
  } else if (modalName === "syotenModal") {
    syotenModalVisible.value = true;
  }
};
const closeModal = (modalName: string): void => {
  if (modalName === "itemModal") {
    itemModalVisible.value = false;
  } else if (modalName === "syotenModal") {
    syotenModalVisible.value = false;
  }
};

// 書誌モーダル関連----------------------------------
// 表示用
let selectedItem = ref({
  item_name: "",
});
const ref_selectItem = (selectedValue: { title: string; syosiCd: string }) => {
  searchConditions.value.syosiCd = selectedValue.syosiCd;
  selectedItem.value.item_name = selectedValue.title;
};
const inputItemCd = (event: any) => {
  searchConditions.value.syosiCd = event.target.value;
  selectedItem.value.item_name = "";
};

// 書店検索関連---------------------------------
// 表示用
const selectedSyoten = ref({
  syotenMei: "",
  bansen: "",
  syotenCd: "",
});
// 書店選択を反映
const ref_selectSyoten = (selectedValue: {
  syotenMei: string;
  syotenCd: string;
  bansen: string;
  toritugiCd: string;
  toritugiSyotenCd: string;
}): void => {
  selectedSyoten.value.syotenMei = selectedValue.syotenMei;
  selectedSyoten.value.bansen = selectedValue.bansen;
  selectedSyoten.value.syotenCd = selectedValue.syotenCd;

  searchConditions.value.toritugiSyotenCd = selectedValue.toritugiSyotenCd;
  searchConditions.value.toritugiCd = selectedValue.toritugiCd;
};

let holdToritugiSyotencd = "";
const focusToritugiSyotenCd = (e: any) => {
  holdToritugiSyotencd = e.target.value;
};
const inputToritugiSyotenCd = (e: string) => {
  searchConditions.value.toritugiSyotenCd = e;
};
const searchSyoten = async (): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (searchConditions.value.toritugiSyotenCd === "") {
    selectedSyoten.value.syotenMei = "";
    selectedSyoten.value.bansen = "";
    selectedSyoten.value.syotenCd = "";
    searchConditions.value.toritugiCd = "";
    searchConditions.value.toritugiSyotenCd = "";
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];
    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
    } else {
      //該当する書店が無ければ以前の状態に戻す
      searchConditions.value.toritugiSyotenCd = holdToritugiSyotencd;
      notyf.error("該当する書店がありません");
    }
  }
};
// ------------------------------------------------
__expose({
  resetConditions,
});
// 検索条件
watch(searchConditions.value, () => {
  store.commit("search/setSearchDetailState", searchConditions.value);
  store.commit("search/setSyotenDetailState", searchConditions.value);
});
// 書店検索用
watch(selectedSyoten, () => {
  store.commit("search/setSyotenDetailState", selectedSyoten);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(itemModalVisible))
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal('itemModal'))),
          onRef_selectSyosi: ref_selectItem
        }))
      : _createCommentVNode("", true),
    (_unref(syotenModalVisible))
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 1,
          toritugiCd: searchConditions.value.toritugiCd,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('syotenModal'))),
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            onChange: startDate,
            type: "date",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchConditions.value.fromDate) = $event))
          }, null, 544), [
            [_vModelText, searchConditions.value.fromDate]
          ]),
          _createTextVNode("～"),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchConditions.value.toDate) = $event))
          }, null, 512), [
            [_vModelText, searchConditions.value.toDate]
          ])
        ]),
        (_unref(route).path.includes('/orderOutOfStock'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchConditions.value.changeableSyukkoSuu) = $event))
                }, null, 512), [
                  [_vModelCheckbox, searchConditions.value.changeableSyukkoSuu]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("input", {
            class: "SearchDetail_Input_Yellow",
            onDblclick: _cache[5] || (_cache[5] = ($event: any) => (showModal('itemModal'))),
            onInput: inputItemCd,
            value: searchConditions.value.syosiCd,
            type: 'number'
          }, null, 40, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("li", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchConditions.value.syubetu) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syubetuList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.syubetu,
                    key: index
                  }, _toDisplayString(option.syubetu), 9, _hoisted_16))
                }), 128))
              ], 512), [
                [_vModelSelect, searchConditions.value.syubetu]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("li", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchConditions.value.category) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.categoryCd,
                    key: index
                  }, _toDisplayString(option.category), 9, _hoisted_21))
                }), 128))
              ], 512), [
                [_vModelSelect, searchConditions.value.category]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("li", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("select", {
                name: "",
                id: "",
                class: "CartNormal_ListContent_Select",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchConditions.value.zaikoStatus) = $event))
              }, [
                _hoisted_26,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zaikoStatusList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.zsId,
                    key: index
                  }, _toDisplayString(option.zsName), 9, _hoisted_27))
                }), 128))
              ], 512), [
                [_vModelSelect, searchConditions.value.zaikoStatus]
              ])
            ])
          ])
        ])
      ]),
      (_unref(route).path.includes('/orderOutOfStock'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("li", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchConditions.value.toritugiCd) = $event))
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                      return _createElementVNode("option", {
                        value: option.toritugiCd,
                        key: index
                      }, _toDisplayString(option.toritugiMei), 9, _hoisted_33)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, searchConditions.value.toritugiCd]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("li", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(InputText, {
                    class: "SearchDetail_Input_Yellow",
                    onDblclick: _cache[10] || (_cache[10] = ($event: any) => (showModal('syotenModal'))),
                    value: searchConditions.value.toritugiSyotenCd,
                    type: 'text',
                    onOnInput: inputToritugiSyotenCd,
                    onOnChange: searchSyoten,
                    onkeydown: "return event.keyCode !== 69",
                    onFocus: focusToritugiSyotenCd
                  }, null, 8, ["value"]),
                  _createVNode(InputText, {
                    class: "SearchDetail_Input_Gray",
                    value: selectedSyoten.value.syotenMei
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})